/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable, NgZone } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { take, mapTo, tap, skip } from 'rxjs/operators';
import { runInZone } from 'src/app/plain-javascript/services/rxjs-internal-extensions';

import { renderQueue } from 'src/app/plain-javascript/services/RenderQueue';
import { logger } from '@touchplan/logging';

@Injectable()
export class WaitForFrameGuard {
	constructor(private ngZone: NgZone) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		// return renderQueue.requestAnimationFramePromise();
		// return true;
		return renderQueue.ob$.pipe(
			skip(1),
			take(1),
			runInZone(this.ngZone),
			mapTo(true),
			tap((thing) => logger.log('frame framed'))
		);
	}
}
